import React, { useState } from 'react';

const RaiseDisputeModal = ({ open, onClose, onSubmit, submitting = false }) => {
    const [reason, setReason] = useState('work_quality');
    const [description, setDescription] = useState('');

    if (!open) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit?.({
            reason,
            description: description.trim(),
        });
    };

    return (
        <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/50 p-4">
            <div
                className="w-full max-w-md rounded-2xl border border-zinc-200 bg-white p-5 shadow-xl dark:border-zinc-700 dark:bg-zinc-950"
                role="dialog"
                aria-modal="true"
            >
                <h2 className="text-lg font-semibold text-zinc-900 dark:text-white">
                    Raise dispute
                </h2>
                <p className="mt-1 text-sm text-zinc-500">
                    This opens a discussion room for your company, the employee, and
                    the dispute admin. On-chain dispute must still be confirmed in
                    your wallet.
                </p>
                <form onSubmit={handleSubmit} className="mt-4 space-y-4">
                    <label className="block space-y-1.5">
                        <span className="text-xs font-medium text-zinc-600 dark:text-zinc-400">
                            Reason
                        </span>
                        <select
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            className="cpg-input w-full"
                        >
                            <option value="work_quality">Work quality</option>
                            <option value="late_delivery">Late delivery</option>
                            <option value="scope_mismatch">Scope mismatch</option>
                            <option value="non_delivery">Work not delivered</option>
                            <option value="payment_issue">Payment issue</option>
                            <option value="other">Other</option>
                        </select>
                    </label>
                    <label className="block space-y-1.5">
                        <span className="text-xs font-medium text-zinc-600 dark:text-zinc-400">
                            Description
                        </span>
                        <textarea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            rows={4}
                            required
                            placeholder="Describe what went wrong…"
                            className="cpg-input min-h-[96px] w-full resize-y"
                        />
                    </label>
                    <div className="flex justify-end gap-2 pt-1">
                        <button
                            type="button"
                            onClick={onClose}
                            disabled={submitting}
                            className="rounded-lg border border-zinc-200 px-4 py-2 text-sm font-semibold text-zinc-700 dark:border-zinc-700 dark:text-zinc-300"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={submitting || !description.trim()}
                            className="rounded-lg bg-rose-600 px-4 py-2 text-sm font-semibold text-white hover:bg-rose-700 disabled:opacity-50"
                        >
                            {submitting ? 'Submitting…' : 'Continue to wallet'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RaiseDisputeModal;
